<div class="form-group custom-control custom-switch">
  <input
    [(ngModel)]="includeChildDocuments"
    type="checkbox"
    class="custom-control-input"
    id="includeChildDocuments"
    name="includeChildDocuments"
  />
  <label for="includeChildDocuments" class="custom-control-label">
    {{ 'files.fileListCard.settings.includeChildDocuments' | translate }}
  </label>
</div>
